import React from "react";
import { observer } from "mobx-react";
import { PermissionViewStore } from "../../store";
import { PermissionViewForm } from "./PermissionViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type PermissionViewProps = {
  permissionViewStore: PermissionViewStore;
};

export const PermissionView: React.FC<PermissionViewProps> = observer(
  ({ permissionViewStore }) => {
    return (
      <div>
        <PermissionViewForm
          name_es={permissionViewStore.name_esValue}
          name_en={permissionViewStore.name_enValue}
          name_pt={permissionViewStore.name_ptValue}
          onPrint={(handlePrint: () => void) =>
            permissionViewStore.printPermission(handlePrint)
          }
          onCancel={() => permissionViewStore.cancelPermission()}
          onEdit={
            permissionViewStore.isEditEnabled
              ? () => permissionViewStore.editPermission()
              : undefined
          }
        />
        <ErrorDialog
          open={permissionViewStore.errorDialogOpened}
          title={permissionViewStore.errorTitle}
          description={permissionViewStore.errorDescription}
          onClose={() => permissionViewStore.closeErrorDialog()}
        />
      </div>
    );
  }
);
